module.exports = __webpack_public_path__ + "static/img/iphone.e43abe7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iphone.png
// module id = Wshg
// module chunks = 1